import {replaceEmailsWithHref} from '../presentLinkInText.js';
import convertJsxToString from './convertJsxToString.js';

/**
 * @param {string} text
 * @param variables
 * @returns {string}
 */
export default function presentText({text = '', variables = {}, useEmailTag = true}) {
  if (!text) return '';
  // Convert React JSX or other types to string
  if (typeof text === 'object') {
    return convertJsxToString(text);
  }

  const result = text.replace(/{{\s*(\w+)\s*}}/g, (match, variable) => {
    if (!variables.hasOwnProperty(variable)) return match;
    return variables[variable];
  });

  // TODO: remove useEmailTag after all text are rendered as HTML
  return useEmailTag ? replaceEmailsWithHref(result) : result;
}

export function hasEmailTag(text) {
  const emailTagPattern = /<a[^>]*href="mailto:[^"]+"[^>]*>/i;
  return emailTagPattern.test(text);
}
